/**
 * Turn an axios-style rejection into the most specific message we can show.
 *
 * Order: DRF's `detail`, then a flattened field-error object
 * (`{field: ["msg", ...]}` -> `field: msg`), then the transport error's own
 * message, and only then the caller's generic fallback.
 */
export function apiErrorText(err: unknown, fallback: string): string {
  const e = err as { response?: { data?: unknown }; message?: unknown } | null | undefined;
  const data = e?.response?.data;

  if (typeof data === 'string' && data.trim()) return data;

  if (data && typeof data === 'object') {
    const detail = (data as Record<string, unknown>).detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
    if (Array.isArray(detail) && detail.length) return detail.join(' ');

    const flat = Object.entries(data as Record<string, unknown>)
      .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(' ') : String(v)}`)
      .join(' · ');
    if (flat) return flat;
  }

  if (typeof e?.message === 'string' && e.message.trim()) return e.message;
  return fallback;
}
